import { useState, useEffect } from 'react';
import { LoadingIcon, Button } from '@prosolve/common-components-ui'
import useDataImages from '../../../../dataHooks/useDataImages';
import UploadImagesModal from './UploadImagesModal';
import { FaUpload } from 'react-icons/fa';
import useIsMobileView from "../../../../hooks/useIsMobileView";
import { ImageLightbox } from '../../../sharedComponents/ImageLightbox';

export default ({
  eventData = {}
}) => {
  const isMobileView = useIsMobileView();

  const eventId = eventData.id

  const [isUploadImagesModalOpen, setIsUploadImagesModalOpen] = useState(false)
  const [isImageLightboxOpen, setIsImageLightboxOpen] = useState()

  const [isLoading, setIsLoading] = useState(false);

  const [images, setImages] = useState([])

  const {
    fetchImages
  } = useDataImages();

  const getImages = async (eventId) => {
    setIsLoading(true)
    try {
      const fbackData = await fetchImages(eventId);
      setImages(fbackData)
    } catch (e) {
      setImages({})
    }
    setIsLoading(false)
  }

  useEffect(() => {
    getImages(eventId)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [eventId])

  const onClickImage = (imageIndex) => {
    setIsImageLightboxOpen({ 
      images: images.map(img => ({ src: img.url, alt: img.name })), 
      initialIndex: imageIndex 
    })
  }

  const onUploadImages = async () => {
    setIsUploadImagesModalOpen(true)
  }

  const onUploadImagesSuccess = async () => {
    setIsUploadImagesModalOpen(false)
    getImages(eventId)
  }

  return (
    <div>
      {
        isUploadImagesModalOpen &&
        <UploadImagesModal 
          eventId={eventId}
          onClose={() => setIsUploadImagesModalOpen(false)}
          onSuccess={onUploadImagesSuccess}
        />
      }
      {
        isImageLightboxOpen &&
        <ImageLightbox 
          {...isImageLightboxOpen} 
          onClose={() => setIsImageLightboxOpen()} 
        />
      }
      {
        isLoading ?
          <div style={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            padding: '20px'
          }}>
            <LoadingIcon />
          </div>
          :
          <div
            style={{
              padding: '20px'
            }}
          >
            <div style={{
              display: 'flex',
              alignItems: 'center'
            }}>
              <div style={{
                flex: 1,
                color: '#565656',
                fontSize: '24px',
                fontWeight: 'bold',
                marginLeft: '20px'
              }}>
                {`Event Images`}
              </div>
              <Button
                style={{
                  display: 'inline-flex',
                  padding: '8px 16px',
                  marginRight: '20px'
                }}
                onClick={onUploadImages}
              >
                <FaUpload style={{ marginRight: '10px', color: '#0280c6' }} />
                <span style={{ fontWeight: 'bold', color: '#565656' }}>{'Upload Images'}</span>
              </Button>
            </div>

            <div style={{
              display: 'flex',
              flexDirection: isMobileView ? 'column' : 'row',
              flexWrap: 'wrap',
              padding: '20px',
              gap: '10px 10px',
              justifyContent: 'left',
            }}>
              {
                images.length > 0 ?
                images
                .map(({ url: imageUrl }, index) => {
                  return (
                    <div 
                      key={`${imageUrl}-${index}`} 
                      style={{ 
                        maxWidth: isMobileView ? '100%' : 'calc(66% - 10px)',
                        cursor: 'pointer',
                        flexGrow: 1,
                        height: '220px',
                      }}
                      onClick={() => onClickImage(index)}
                    >
                      <img 
                        style={{ 
                          width: '100%', 
                          maxHeight: '100%',
                          minWidth: '100%',
                          objectFit: 'cover',
                          borderRadius: '5px' 
                        }} 
                        src={imageUrl} alt='uploadedEventPic' />
                    </div>
                  )
                })
                :
                <div style={{
                  color: '#808080',
                  fontSize: '14px',
                  textAlign: 'center',
                  width: '100%',
                  // marginLeft: '20px',
                }}>
                  No photos available.
                </div>
              }
            </div>
            
          </div>
      }
    </div>
  )
}